<template>
    <div id="content" v-if="!loading">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction" />
      <form>
        <div class="inner">
            <p class="buttons" v-if="isEditable || this.$_updateActionAllowed">
              <span
                  @click.prevent.stop="toggleShowResult"
                  class="switch switch_edit_summary"
                  :class="{switched: showResult}"
                  :title="showResultSwitchTitle"
              >
								<span class="switch_btn"></span>
							</span>
              <a  class="btn btn_action btn_delete" :title="'Smazat' | translate"
                   @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
            </p>
            <h1 v-if="entity.name">{{ entity.name }}</h1>
          <h1 v-else v-translate>Detail konfigurace zařízení</h1>
        </div>

        <div class="responsiveTabs" v-if="!loading">

            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigDetailProperties'}"><a @click.stop="openRoute('deviceConfigDetailProperties')" v-translate>Vlastnosti</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigDetailPlatform'}"><a @click.stop="openRoute('deviceConfigDetailPlatform')" v-translate>Platforma</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigDetailDevice'}"><a @click.stop="openRoute('deviceConfigDetailDevice')" v-translate>Zařízení</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigDetailPlayer'}"><a @click.stop="openRoute('deviceConfigDetailPlayer')" v-translate>Přehrávač</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigDetailFunctions'}"><a @click.stop="openRoute('deviceConfigDetailFunctions')" v-translate>Funkce</a></li>
            </ul>

          <keep-alive>
            <router-view
                :isEditable="isEditable"
                :entity="entity"
                :deviceTypes="deviceTypes"
                :availableValues="availableValues"
                :operatorOptions="operatorOptions"
                :operatorIdComputed="operatorIdComputed"
            />
          </keep-alive>

            <section class="buttons" v-if="isEditable">
                <p>
                    <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam konfigurací zařízení</router-link>
                    <input type="submit" :value="'Uložit' | translate"
                           :class="['btn']"
                           @click.prevent.stop="submitForm()">
                </p>
            </section>
        </div>
      </form>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import deviceConfigs from "@/components/views/deviceConfigs/mixins/deviceConfigs"

export default {
    name: "DeviceConfigDetail",
    mixins: [detailActions, deviceConfigs],
    data() {
        return {
            deviceTypes: [],
            availableValues: {},
            loading: true,
            showResult: false,
        }
    },
    created(DeviceConfigService, OperatorService) {
        this.entityService = DeviceConfigService;

        if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.operatorService = OperatorService
            this.getOperators().then(() =>{
              this.operators = [{'id': null, 'name': this.$gettext('Nenastaven')}, ...this.operators];
            });
        }

        this.getDependency().then(() => {
            this.createdInit();
        });
    },
    computed: {
        isEditable() {
            return this.$_updateActionAllowed && !this.showResult;
        },
      showResultSwitchTitle(){
          return !this.showResult
            ? this.$gettext("Zobrazit výslednou konfiguraci")
            : this.$gettext("Zobrazit editační mód");
      }
    },
    methods: {
        getResultEntity(){
          this.setLoadingMessage()

          return this.entityService.getDeviceConfigResult(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
              .then(data => {
                this.entity = data.device_config
                this.emptyMessage()
              })
              .catch(function (error) {
                this.setErrorMessage(error['error_message'])
              }.bind(this))
        },
        getEntity() {
            this.setLoadingMessage()

            return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                .then(data => {
                    this.entity = data.device_config
                    this.emptyMessage()
                })
                .catch(function (error) {
                    this.setErrorMessage(error['error_message'])
                }.bind(this))
        },
        updateEntity(params, redirect = false) {
            this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
                .then(() => {
                    if (redirect === true) {
                        this.redirect(this.moduleName)
                    } else {
                        this.emptyMessage();
                        this.setSuccessMessage();
                        this.getEntity();
                    }
                })
                .catch(function (error) {
                    this.setErrorMessage(this.processErrorMessage(error))
                }.bind(this))
        },
      toggleShowResult(){
          this.showResult = !this.showResult;
          if(this.showResult){
            this.getResultEntity();
          }else{
            this.getEntity();
          }
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/DeviceConfigDetail.vue